<asax-header></asax-header>
<div style="height: calc(100vh - 54px);">
  <as-split direction="vertical"
            unit="percent"
            [gutterSize]="gutterSize"
            [gutterDblClickDuration]="gutterDoubleClickDuration"
            (dragEnd)="dragEndSkyViewHeight($event)"
            (gutterDblClick)="resetSkyViewHeight()">
    <as-split-area [size]="skyViewHeight">
      <as-split direction="horizontal"
                unit="percent"
                [gutterSize]="gutterSize"
                [gutterDblClickDuration]="gutterDoubleClickDuration"
                (dragEnd)="dragEndSkyViewWidth($event)"
                (gutterDblClick)="resetSkyViewWidth()">
        <as-split-area #skyView
                       [size]="skyViewWidth">
          <asax-sky-view [height]="skyView?.offsetHeight"
                         [width]="skyView?.offsetWidth">
          </asax-sky-view>
        </as-split-area>
        <as-split-area #frequencyView
                       [size]="(100 - skyViewWidth)">
          <asax-frequency-view [height]="frequencyView?.offsetHeight"
                               [width]="frequencyView?.offsetWidth">
          </asax-frequency-view>
        </as-split-area>
      </as-split>
    </as-split-area>
    <as-split-area #resultTable
                   [size]="(100 - skyViewHeight)">
      <asax-result-table [height]="resultTable?.offsetHeight"
                         [width]="resultTable?.offsetWidth">
      </asax-result-table>
    </as-split-area>
  </as-split>
</div>
